import { render, staticRenderFns } from "./SectionTitle.vue?vue&type=template&id=a55957f0&"
import script from "./SectionTitle.vue?vue&type=script&lang=js&"
export * from "./SectionTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/juodeliai/miskovezis-core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a55957f0')) {
      api.createRecord('a55957f0', component.options)
    } else {
      api.reload('a55957f0', component.options)
    }
    module.hot.accept("./SectionTitle.vue?vue&type=template&id=a55957f0&", function () {
      api.rerender('a55957f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/resources/static/js/app/components/common/SectionTitle.vue"
export default component.exports